import { CheckboxProps, FormControlLabel, FormGroup, FormHelperText, Checkbox as MuiCheckbox } from "@mui/material";
import dayjs from "dayjs";
import { Controller, useFormContext } from "react-hook-form";
import { Typography } from "./Typography";
import { ReactNode } from "react";

type Props = CheckboxProps;

export const Checkbox = ({ ...props }: Props) => {
  return <MuiCheckbox {...props} />;
};

export type FormCheckboxProps = {
  name: string;
  label?: ReactNode | string;
  optional?: boolean;
} & Props;

export const FormCheckbox = ({ name, disabled, sx, optional = false, label = "", ...props }: FormCheckboxProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onBlur, onChange, value }, fieldState: { error } }) => (
        <FormGroup sx={sx}>
          <FormControlLabel
            label={typeof label === "string" ? <Typography variant="body2">{optional ? `${label} (optional)` : label}</Typography> : label}
            control={
              <Checkbox
                checked={!!value}
                disabled={disabled}
                inputProps={{ "aria-label": "controlled" }}
                onBlur={onBlur}
                onChange={(e) => onChange(e.target.checked)}
                {...props}
              />
            }
          />
          {!disabled && error?.message && (
            <FormHelperText error={!disabled && !!error}>{!disabled && error?.message ? error.message : ""}</FormHelperText>
          )}
        </FormGroup>
      )}
    />
  );
};

export const FormCheckboxWithDayjsValue = ({ name, disabled, optional = false, label = "", ...props }: FormCheckboxProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onBlur, onChange, value }, fieldState: { error } }) => (
        <FormGroup>
          <FormControlLabel
            label={typeof label === "string" ? <Typography variant="body2">{optional ? `${label} (optional)` : label}</Typography> : label}
            control={
              <Checkbox
                checked={!!value}
                disabled={disabled}
                inputProps={{ "aria-label": "controlled" }}
                onBlur={onBlur}
                onChange={() => onChange(value ? undefined : dayjs(new Date()))}
                {...props}
              />
            }
          />
          {!disabled && error?.message && (
            <FormHelperText error={!disabled && !!error}>{!disabled && error?.message ? error.message : ""}</FormHelperText>
          )}
        </FormGroup>
      )}
    />
  );
};
